import {combineReducers} from '@reduxjs/toolkit';

import {entitlementResourceChangeLogStateSlice} from './slices/entitlement-resource-change-log-state.slice';
import {entitlementResourceChangeLogSlice} from './slices/entitlement-resource-change-log.slice';

export const entitlementResourceChangeLogReducer = combineReducers({
    events: entitlementResourceChangeLogSlice.reducer,
    state: entitlementResourceChangeLogStateSlice.reducer,
});
